import { DialogTheme } from '../../types';

export const DIALOG_DEFAULT_THEME: DialogTheme = {
    bar: {
        minHeight: 60,
        paddingY: 12,
        background: 'background.content',
        borderWidth: 1,
        closeButtonSize: 's',
    },
    size: {
        xs: '320px',
        s: '380px',
        m: '500px',
        l: '700px',
        xl: '900px',
    },
    animationDuration: {
        open: 300,
        close: 200,
    },
    radius: '20px',
    backdrop: {
        opacity: 0.6,
        blur: 3,
    },
};
